(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/carousel/assets/javascripts/carousel-manager.js') >= 0) return;  svs.modules.push('/components/lb-ui/carousel/assets/javascripts/carousel-manager.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }

const onScrollEnd = svs.components.lbUtils.onScrollEnd;
const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  breakpoints = _svs$components$lbUti.breakpoints,
  BREAKPOINT_AM = _svs$components$lbUti.BREAKPOINT_AM,
  BREAKPOINT_MD = _svs$components$lbUti.BREAKPOINT_MD;
const _svs$components$lbUi$ = svs.components.lbUi.carousel.utils,
  DragState = _svs$components$lbUi$.DragState,
  MouseEvents = _svs$components$lbUi$.MouseEvents,
  TouchEvents = _svs$components$lbUi$.TouchEvents,
  supportsTouch = _svs$components$lbUi$.supportsTouch,
  modulus = _svs$components$lbUi$.modulus;
const selectors = ['a[href]:not([disabled])', 'button:not([disabled])', 'textarea:not([disabled])', 'input[type="text"]:not([disabled])', 'input[type="radio"]:not([disabled])', 'input[type="checkbox"]:not([disabled])', 'select:not([disabled])', ':scope [tabindex]:not([disabled])'].join(',');
var _container = new WeakMap();
var _navigation = new WeakMap();
var _navigationDots = new WeakMap();
var _prevButton = new WeakMap();
var _nextButton = new WeakMap();
var _indexButtons = new WeakMap();
var _a11yPrevious = new WeakMap();
var _a11yNext = new WeakMap();
var _parser = new WeakMap();
var _dragHandlers = new WeakMap();
var _deviceEvent = new WeakMap();
var _enabled = new WeakMap();
var _mobileIndex = new WeakMap();
var _isScrolling = new WeakMap();
var _view = new WeakMap();
var _mouse = new WeakMap();
var _itemsPerPage = new WeakMap();
var _options = new WeakMap();
var _useSameHeight = new WeakMap();
var _observer = new WeakMap();
var _touch = new WeakMap();
var _desktopBp = new WeakMap();
var _mobileBp = new WeakMap();
class CarouselManager {
  constructor(element) {
    var _classPrivateFieldGet3;
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classPrivateFieldInitSpec(this, _container, void 0);
    _classPrivateFieldInitSpec(this, _navigation, void 0);
    _classPrivateFieldInitSpec(this, _navigationDots, void 0);
    _classPrivateFieldInitSpec(this, _prevButton, void 0);
    _classPrivateFieldInitSpec(this, _nextButton, void 0);
    _classPrivateFieldInitSpec(this, _indexButtons, void 0);
    _classPrivateFieldInitSpec(this, _a11yPrevious, void 0);
    _classPrivateFieldInitSpec(this, _a11yNext, void 0);
    _classPrivateFieldInitSpec(this, _parser, new DOMParser());
    _classPrivateFieldInitSpec(this, _dragHandlers, []);
    _classPrivateFieldInitSpec(this, _deviceEvent, void 0);
    _classPrivateFieldInitSpec(this, _enabled, true);
    _classPrivateFieldInitSpec(this, _mobileIndex, 0);
    _classPrivateFieldInitSpec(this, _isScrolling, false);
    _classPrivateFieldInitSpec(this, _view, false);
    _classPrivateFieldInitSpec(this, _mouse, {
      x: 0,
      y: 0
    });
    _classPrivateFieldInitSpec(this, _itemsPerPage, void 0);
    _classPrivateFieldInitSpec(this, _options, {
      align: 'start',
      gutter: 1,
      isMobile: false,
      itemsPerPage: 4
    });
    _classPrivateFieldInitSpec(this, _useSameHeight, false);
    _classPrivateFieldInitSpec(this, _observer, null);
    _classPrivateFieldInitSpec(this, _touch, void 0);
    _classPrivateFieldInitSpec(this, _desktopBp, "(min-width:".concat(breakpoints.values.get(BREAKPOINT_MD), "px)"));
    _classPrivateFieldInitSpec(this, _mobileBp, "(max-width:".concat(breakpoints.values.get(BREAKPOINT_AM) - 0.02, "px)"));
    _defineProperty(this, "numberOfPages", void 0);
    _defineProperty(this, "children", []);
    _defineProperty(this, "actualChildren", []);
    _defineProperty(this, "index", 0);
    _defineProperty(this, "slideIndex", 0);
    _defineProperty(this, "placeholders", []);
    _defineProperty(this, "status", DragState.IDLE);
    _defineProperty(this, "onKeyboardNavigation", e => {
      e.preventDefault();
      if (['ArrowLeft', 'ArrowRight'].includes(e.key)) {
        const focusedIndex = [..._classPrivateFieldGet(_navigationDots, this).children].findIndex(dot => dot === document.activeElement);
        const direction = e.key === 'ArrowLeft' ? -1 : 1;
        const nextIndex = modulus(focusedIndex + direction, this.numberOfPages);
        _classPrivateFieldGet(_navigationDots, this).children[nextIndex].focus();
      }
    });
    _classPrivateFieldSet(_container, this, element.querySelector('.js-carousel-items'));
    this.el = element;
    this.actualChildren = [...element.querySelectorAll('.js-carousel-item')];
    _classPrivateFieldSet(_options, this, this.mergeOptions(_classPrivateFieldGet(_options, this), options));
    _classPrivateFieldSet(_useSameHeight, this, this.el.classList.contains('carousel-items-same-height'));

    ['mergeOptions', 'createElementFromHTML', 'handleTransforms', 'init', 'setupStyles', 'setupPlaceholders', 'setupNavigation', 'setupAccessibility', 'setupObserver', 'toggleHidden', 'enable', 'disable', 'getLocationFromEvent', 'handleOnScrollEnd', 'updateInteraction', 'updateNavigation', 'togglePreviousButton', 'toggleNextButton', 'updatePlaceholders', 'transformCards', 'getPositionForPageIndex', 'getPositionForSlideIndex', 'moveToPageIndex', 'moveToSlideIndex', 'onRelease', 'onStart', 'onMove', 'onEnd', 'onResize', 'onKeyboardNavigation', 'onPrevious', 'onNext', 'onPreviousSlide', 'onNextSlide', 'onIndex', 'addListeners', 'removeListeners', 'destroy'].forEach(fn => {
      this[fn] = this[fn].bind(this);
    });
    const _classPrivateFieldGet2 = _classPrivateFieldGet(_options, this),
      selectedIndex = _classPrivateFieldGet2.selectedIndex;
    _classPrivateFieldSet(_itemsPerPage, this, (_classPrivateFieldGet3 = _classPrivateFieldGet(_options, this)) === null || _classPrivateFieldGet3 === void 0 ? void 0 : _classPrivateFieldGet3.itemsPerPage);
    this.setupStyles();
    this.setupAccessibility();
    this.setupNavigation();
    this.setupPlaceholders();
    this.setupObserver();
    this.onResize();
    this.index = this.actualChildren.length > _classPrivateFieldGet(_itemsPerPage, this) && selectedIndex > 0 ? Math.floor(selectedIndex / _classPrivateFieldGet(_itemsPerPage, this)) : 0;
    this.updateInteraction();
    this.addListeners();
    this.init();
  }
  mergeOptions(a, b) {
    return Object.keys(_objectSpread(_objectSpread({}, a), b)).reduce((acc, key) => {
      acc[key] = b[key] || a[key];
      return acc;
    }, {});
  }
  setItemsHeight() {
    if (_classPrivateFieldGet(_useSameHeight, this)) {
      _classPrivateFieldGet(_container, this).style.height = '';
      this.children.forEach(item => {
        item.style.height = '';
      });
      let maxHeight = 0;
      const items = this.children.filter(child => !child.classList.contains('carousel-item-placeholder'));
      if (items.length > 0) {
        items.forEach(item => {
          if (item.offsetHeight > maxHeight) {
            maxHeight = item.offsetHeight;
          }
        });
        if (maxHeight > 0) {
          _classPrivateFieldGet(_container, this).style.height = "".concat(maxHeight + 24, "px");
          this.children.forEach(item => {
            item.style.height = '100%';
          });
        }
      }
    }
  }
  createElementFromHTML(htmlString) {
    const div = document.createElement('div');
    div.innerHTML = htmlString.trim();
    return div.firstChild;
  }
  handleTransforms() {
    this.transformCards(_classPrivateFieldGet(_container, this));
    if (!_classPrivateFieldGet(_isScrolling, this)) {
      _classPrivateFieldSet(_isScrolling, this, onScrollEnd(_classPrivateFieldGet(_container, this), () => {
        this.updateNavigation();
        _classPrivateFieldSet(_isScrolling, this, false);
      }));
    }
  }
  init() {
    var _this$actualChildren;
    if (_classPrivateFieldGet(_view, this) === CarouselManager.MOBILE) {
      this.transformCards(_classPrivateFieldGet(_container, this));
      _classPrivateFieldGet(_container, this).addEventListener('scroll', this.handleTransforms);
    }

    if (_classPrivateFieldGet(_mobileIndex, this) !== null) {
      const readIndex = Math.floor(_classPrivateFieldGet(_mobileIndex, this) / _classPrivateFieldGet(_itemsPerPage, this));
      if (readIndex !== this.index) {
        this.index = readIndex || 0;
      }
      _classPrivateFieldSet(_mobileIndex, this, null);
    }
    if (_classPrivateFieldGet(_view, this) === CarouselManager.MOBILE) {
      this.disable();
    } else {
      this.enable();
    }

    this.numberOfPages = Math.ceil(((_this$actualChildren = this.actualChildren) === null || _this$actualChildren === void 0 ? void 0 : _this$actualChildren.length) / _classPrivateFieldGet(_itemsPerPage, this));
    if (_classPrivateFieldGet(_view, this) === CarouselManager.MOBILE) {
      setTimeout(() => {
        if (_classPrivateFieldGet(_container, this).scrollLeft === 0) {
          _classPrivateFieldGet(_container, this).scrollTo({
            left: 20,
            behavior: 'smooth'
          });
        }
      }, 100);
    }
  }
  setupObserver() {
    const callback = entries => entries.forEach(entry => this.toggleHidden(entry.target, !entry.isIntersecting));
    _classPrivateFieldSet(_observer, this, new IntersectionObserver(callback, {
      root: _classPrivateFieldGet(_container, this),
      threshold: 0.9
    }));
    this.children.forEach(item => {
      _classPrivateFieldGet(_observer, this).observe(item);
    });
  }
  setupAccessibility() {
    _classPrivateFieldSet(_a11yPrevious, this, this.el.querySelector('.js-carousel-a11y-previous'));
    _classPrivateFieldSet(_a11yNext, this, this.el.querySelector('.js-carousel-a11y-next'));
  }
  setupStyles() {
    const _classPrivateFieldGet4 = _classPrivateFieldGet(_options, this),
      cardSize = _classPrivateFieldGet4.cardSize,
      gutter = _classPrivateFieldGet4.gutter;
    this.el.style.setProperty('--carousel-gutter', gutter);
    this.el.style.setProperty('--carousel-card-size', cardSize ? "".concat(cardSize, "px") : '');
    if (_classPrivateFieldGet(_itemsPerPage, this)) {
      this.el.style.setProperty('--carousel-per-page', _classPrivateFieldGet(_itemsPerPage, this));
    }
  }
  setupPlaceholders() {
    var _this$actualChildren2, _this$actualChildren3;
    if (!_classPrivateFieldGet(_itemsPerPage, this) || _classPrivateFieldGet(_view, this) === CarouselManager.MOBILE) {
      return;
    }
    const pad = Math.ceil((((_this$actualChildren2 = this.actualChildren) === null || _this$actualChildren2 === void 0 ? void 0 : _this$actualChildren2.length) || 1) / _classPrivateFieldGet(_itemsPerPage, this)) * _classPrivateFieldGet(_itemsPerPage, this) - ((_this$actualChildren3 = this.actualChildren) === null || _this$actualChildren3 === void 0 ? void 0 : _this$actualChildren3.length);
    this.placeholders = [...Array(pad).keys()].map(() => _classPrivateFieldGet(_parser, this).parseFromString("\n      <div aria-hidden=\"true\" class=\"carousel-item carousel-item-placeholder\" role=\"listitem\" tabindex=\"-1\">\n        <div class=\"carousel-item-inner\">\n          <div class=\"carousel-placeholder-item\" />\n        </div>\n      </div>\n    ", 'text/html').body.firstElementChild);
    this.placeholders.forEach(item => {
      _classPrivateFieldGet(_container, this).appendChild(item);
    });
    this.children = [...this.actualChildren, ...this.placeholders];
  }
  updatePlaceholders() {
    const existingPlaceholders = new Set(Array.from(_classPrivateFieldGet(_container, this).querySelectorAll('.carousel-item-placeholder')));
    if (_classPrivateFieldGet(_view, this) !== CarouselManager.MOBILE) {
      this.placeholders.forEach(item => {
        if (!existingPlaceholders.has(item)) {
          _classPrivateFieldGet(_container, this).appendChild(item);
        }
      });
      this.children = [...this.actualChildren, ...this.placeholders];
    } else {
      existingPlaceholders.forEach(item => item.remove());
      this.children = [...this.actualChildren];
    }
  }
  setupNavigation() {
    _classPrivateFieldSet(_navigation, this, this.el.querySelector('.js-carousel-navigation'));
    _classPrivateFieldSet(_navigationDots, this, this.el.querySelector('.js-carousel-navigation-dots'));
    _classPrivateFieldSet(_prevButton, this, this.el.querySelector('.js-carousel-navigation-previous'));
    _classPrivateFieldSet(_nextButton, this, this.el.querySelector('.js-carousel-navigation-next'));
    _classPrivateFieldGet(_prevButton, this).setAttribute('tabindex', -1);
    _classPrivateFieldGet(_nextButton, this).setAttribute('tabindex', -1);
    this.updateNavigation();
  }
  toggleHidden(item, isHidden) {
    const isPlaceholder = item.classList.contains('carousel-item-placeholder');
    if (isPlaceholder || !item) {
      return;
    }
    item.setAttribute('aria-hidden', isHidden || isPlaceholder ? 'true' : 'false');
    if (isHidden) {
      const elements = [...item.querySelectorAll(selectors)];
      for (const element of elements) {
        element.classList.add('carousel-item-unfocusable');
        if (element.hasAttribute('tabindex')) {
          element.dataset.tab = element.tabIndex;
        }
        element.setAttribute('tabindex', '-1');
      }
    } else {
      const elements = [...item.querySelectorAll('.carousel-item-unfocusable')];
      for (const element of elements) {
        element.classList.remove('carousel-item-unfocusable');
        if (element.hasAttribute('data-tab')) {
          element.setAttribute('tabindex', element.dataset.tab);
        } else {
          element.removeAttribute('tabindex');
        }
      }
    }
  }
  enable() {
    this.enabled = true;
  }
  disable() {
    this.enabled = false;
  }
  getLocationFromEvent(e) {
    return {
      x: _classPrivateFieldGet(_touch, this) ? e.changedTouches[0].clientX : e.pageX,
      y: _classPrivateFieldGet(_touch, this) ? e.changedTouches[0].clientY : e.pageY
    };
  }
  updateInteraction(touch) {
    _classPrivateFieldSet(_touch, this, touch);
    _classPrivateFieldSet(_deviceEvent, this, touch ? TouchEvents : MouseEvents);
  }
  updateNavigation() {
    this.numberOfPages = Math.ceil(this.actualChildren.length / _classPrivateFieldGet(_itemsPerPage, this)) || 1;
    if (this.numberOfPages <= 1 || _classPrivateFieldGet(_view, this) === CarouselManager.MOBILE) {
      this.el.classList.remove('carousel-with-navigation');
    } else {
      this.el.classList.add('carousel-with-navigation');
    }
    if (_classPrivateFieldGet(_view, this) !== CarouselManager.MOBILE) {
      _classPrivateFieldGet(_navigationDots, this).innerHTML = '';
      if (this.numberOfPages > 1) {
        for (let i = 0; i < this.numberOfPages; i++) {
          const selected = i === this.index;
          const page = i + 1;
          const dot = this.createElementFromHTML("\n            <button\n              aria-label=\"Visa sida ".concat(page, " av ").concat(this.numberOfPages, "\"\n              ").concat(selected ? 'aria-selected="true"' : '', "\n              class=\"icon-button carousel-nav-item js-carousel-navigation-item").concat(selected ? ' carousel-nav-item-active' : '', "\"\n              role=\"tab\"\n            >\n              <span class=\"carousel-nav-icon carousel-nav-icon-").concat(_classPrivateFieldGet(_options, this).size || 300, "\" />\n            </button>\n          "));
          _classPrivateFieldGet(_navigationDots, this).appendChild(dot);
          dot.addEventListener('click', this.onIndex);
        }
      }
    }
    _classPrivateFieldSet(_indexButtons, this, [...this.el.querySelectorAll('.js-carousel-navigation-item')]);
    [..._classPrivateFieldGet(_indexButtons, this)].forEach((item, i) => {
      item.dataset.index = i;
    });
    this.index = Math.min(this.index, this.numberOfPages - 1);
    _classPrivateFieldGet(_indexButtons, this).forEach(btn => {
      if (parseInt(btn.dataset.index, 10) === this.index) {
        btn.classList.add('carousel-nav-item-active');
      } else {
        btn.classList.remove('carousel-nav-item-active');
      }
    });
    this.togglePreviousButton(this.index !== 0);
    this.toggleNextButton(this.index !== this.numberOfPages - 1);
  }
  togglePreviousButton(state) {
    if (state) {
      _classPrivateFieldGet(_prevButton, this).classList.remove('disabled');
      if (_classPrivateFieldGet(_view, this) === CarouselManager.MOBILE) {
        _classPrivateFieldGet(_a11yPrevious, this).classList.remove('a11y-carousel-nav-button-disabled');
        _classPrivateFieldGet(_a11yPrevious, this).removeAttribute('aria-disabled');
      }
    } else {
      _classPrivateFieldGet(_prevButton, this).classList.add('disabled');
      if (_classPrivateFieldGet(_view, this) === CarouselManager.MOBILE) {
        _classPrivateFieldGet(_a11yPrevious, this).classList.add('a11y-carousel-nav-button-disabled');
        _classPrivateFieldGet(_a11yPrevious, this).setAttribute('aria-disabled', 'true');
      }
    }
  }
  toggleNextButton(state) {
    if (state) {
      _classPrivateFieldGet(_nextButton, this).classList.remove('disabled');
      if (_classPrivateFieldGet(_view, this) === CarouselManager.MOBILE) {
        _classPrivateFieldGet(_a11yNext, this).classList.remove('a11y-carousel-nav-button-disabled');
        _classPrivateFieldGet(_a11yNext, this).removeAttribute('aria-disabled');
      }
    } else {
      _classPrivateFieldGet(_nextButton, this).classList.add('disabled');
      if (_classPrivateFieldGet(_view, this) === CarouselManager.MOBILE) {
        _classPrivateFieldGet(_a11yNext, this).classList.add('a11y-carousel-nav-button-disabled');
        _classPrivateFieldGet(_a11yNext, this).setAttribute('aria-disabled', 'true');
      }
    }
  }

  transformCards(el) {
    if (_classPrivateFieldGet(_view, this) === CarouselManager.MOBILE && this.el.classList.contains('carousel-mobile-flat')) {
      return;
    }
    if (el) {
      const parentBounds = el.getBoundingClientRect();
      const parentCenter = Math.round(parentBounds.left + parentBounds.width / 2);
      for (let i = 0; i < el.children.length; i++) {
        const card = el.children[i];
        const cardBounds = card.getBoundingClientRect();
        const cardCenter = Math.round(cardBounds.left + cardBounds.width / 2);
        const diff = Math.abs(cardCenter - parentCenter);
        card.firstElementChild.style.setProperty('--offset', Math.min(1, Math.round(diff / cardBounds.width * 100) / 100));
        if (diff < 50) {
          _classPrivateFieldSet(_mobileIndex, this, i);
        }
      }
    }
  }

  getPositionForPageIndex(index) {
    const children = [...(this.children || [])];
    if (!children.length) {
      return -1;
    }
    const bounds = children[0].getBoundingClientRect();
    const n = Math.min(children.length - _classPrivateFieldGet(_itemsPerPage, this), index * _classPrivateFieldGet(_itemsPerPage, this));
    return n === 0 ? -1 : Math.max(0, n * bounds.width);
  }

  moveToPageIndex(index) {
    let instant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    const x = this.getPositionForPageIndex(Number.isInteger(index) ? index : this.index);
    this.index = index;
    this.updateNavigation();
    if (_classPrivateFieldGet(_container, this).scrollLeft !== x) {
      _classPrivateFieldGet(_container, this).scrollTo({
        left: x,
        behavior: instant ? 'instant' : 'smooth'
      });
    }
  }

  onRelease(index) {
    window.removeEventListener(_classPrivateFieldGet(_deviceEvent, this).MOVE, this.onMove);
    window.removeEventListener(_classPrivateFieldGet(_deviceEvent, this).STOP, this.onEnd);
    _classPrivateFieldSet(_isScrolling, this, false);
    this.index = index;
    this.moveToPageIndex(index);
  }

  onStart(e) {
    if (!_classPrivateFieldGet(_enabled, this) || e.target.closest('button') || e.target.closest('a')) {
      return;
    }
    if (e.type === MouseEvents.START) {
      e.preventDefault();
    }
    window.removeEventListener(_classPrivateFieldGet(_deviceEvent, this).MOVE, this.onMove);
    window.removeEventListener(_classPrivateFieldGet(_deviceEvent, this).STOP, this.onEnd);
    window.addEventListener(_classPrivateFieldGet(_deviceEvent, this).MOVE, this.onMove, {
      passive: false
    });
    window.addEventListener(_classPrivateFieldGet(_deviceEvent, this).STOP, this.onEnd, {
      passive: false
    });
    _classPrivateFieldSet(_mouse, this, this.getLocationFromEvent(e));
    _classPrivateFieldSet(_isScrolling, this, true);
    this.status = DragState.START;
    requestAnimationFrame(() => {
      this.status = DragState.DRAGGING;
    });
  }

  onMove(e) {
    if (_classPrivateFieldGet(_enabled, this)) {
      e.preventDefault();
    }
    if (_classPrivateFieldGet(_view, this) !== CarouselManager.MOBILE) {
      const p = this.getLocationFromEvent(e);
      const dist = {
        x: p.x - _classPrivateFieldGet(_mouse, this).x,
        y: p.y - _classPrivateFieldGet(_mouse, this).y
      };
      if (Math.abs(dist.x) > CarouselManager.DRAG_THRESHOLD) {
        const newIndex = dist.x > 0 ? Math.max(0, this.index - 1) : Math.min(this.numberOfPages - 1, this.index + 1);
        this.onRelease(newIndex);
      }
    }
  }

  onEnd(e) {
    if (_classPrivateFieldGet(_enabled, this) && e.type === MouseEvents.START) {
      e.preventDefault();
    }
    window.removeEventListener(_classPrivateFieldGet(_deviceEvent, this).MOVE, this.onMove);
    window.removeEventListener(_classPrivateFieldGet(_deviceEvent, this).STOP, this.onEnd);
    this.status = DragState.END;
    requestAnimationFrame(() => {
      this.status = DragState.IDLE;
    });
    _classPrivateFieldSet(_isScrolling, this, false);
  }
  onResize() {
    const touch = supportsTouch();
    const _classPrivateFieldGet5 = _classPrivateFieldGet(_options, this),
      isMobile = _classPrivateFieldGet5.isMobile,
      itemsPerPage = _classPrivateFieldGet5.itemsPerPage;
    if (_classPrivateFieldGet(_touch, this) !== touch) {
      this.updateInteraction(touch);
    }
    if (touch && (window.matchMedia(_classPrivateFieldGet(_mobileBp, this)).matches || isMobile)) {
      if (_classPrivateFieldGet(_view, this) !== CarouselManager.MOBILE) {
        this.el.classList.add('carousel-mobile');
        _classPrivateFieldSet(_view, this, CarouselManager.MOBILE);
      }
    } else {
      const currentCount = _classPrivateFieldGet(_itemsPerPage, this);
      this.el.classList.remove('carousel-mobile');
      if (this.actualChildren.length > (itemsPerPage || 4)) {
        if (window.matchMedia(_classPrivateFieldGet(_desktopBp, this)).matches && _classPrivateFieldGet(_view, this) !== CarouselManager.DESKTOP) {
          _classPrivateFieldSet(_view, this, CarouselManager.DESKTOP);
          _classPrivateFieldSet(_itemsPerPage, this, itemsPerPage || 4);
        } else if (!window.matchMedia(_classPrivateFieldGet(_desktopBp, this)).matches && _classPrivateFieldGet(_view, this) !== CarouselManager.TABLET) {
          _classPrivateFieldSet(_view, this, CarouselManager.TABLET);
          _classPrivateFieldSet(_itemsPerPage, this, itemsPerPage || 3);
        }
      }
      this.moveToPageIndex(this.index, true);
      if (currentCount !== _classPrivateFieldGet(_itemsPerPage, this)) {
        this.el.style.setProperty('--carousel-per-page', _classPrivateFieldGet(_itemsPerPage, this));
      }
    }
    this.updatePlaceholders();
    this.updateNavigation();
    this.setItemsHeight();
  }
  onPrevious() {
    if (this.index > 0) {
      this.moveToPageIndex(this.index - 1);
    }
  }
  onNext() {
    if (this.index + 1 < this.numberOfPages) {
      this.moveToPageIndex(this.index + 1);
    }
  }
  handleOnScrollEnd(newSlideIndex) {
    const slide = _classPrivateFieldGet(_container, this).children[newSlideIndex];
    _classPrivateFieldGet(_container, this).addEventListener('scrollend', () => {
      if (slide !== document.activeElement) {
        slide.focus();
      }
    }, {
      once: true
    });
  }
  onPreviousSlide() {
    if (this.slideIndex > 0) {
      const newSlideIndex = this.slideIndex - 1;
      this.moveToSlideIndex(newSlideIndex);
      this.handleOnScrollEnd(newSlideIndex);
    }
  }
  onNextSlide() {
    if (this.slideIndex + 1 < this.children.length) {
      const newSlideIndex = this.slideIndex + 1;
      this.moveToSlideIndex(newSlideIndex);
      this.handleOnScrollEnd(newSlideIndex);
    }
  }
  getPositionForSlideIndex(index) {
    const children = [...(this.children || [])];
    if (!children.length) {
      return -1;
    }
    const bounds = children[0].getBoundingClientRect();
    const offset = _classPrivateFieldGet(_view, this) === CarouselManager.MOBILE ? Math.round(bounds.width / 2) : 0;
    return offset + index * bounds.width;
  }
  moveToSlideIndex(index) {
    const x = this.getPositionForSlideIndex(index);
    this.slideIndex = index;
    if (_classPrivateFieldGet(_container, this).scrollLeft !== x) {
      _classPrivateFieldGet(_container, this).scrollTo({
        left: x,
        behavior: 'smooth'
      });
    }
    setTimeout(() => {
      this.updateNavigation();
    }, 300);
  }
  onIndex(e) {
    const btn = e.target.closest('.js-carousel-navigation-item');
    const index = parseInt(btn === null || btn === void 0 ? void 0 : btn.dataset.index, 10);
    this.moveToPageIndex(index || 0);
  }
  addListeners() {
    window.addEventListener('resize', this.onResize);
    if (this.el && this.el instanceof Element) {
      var _classPrivateFieldGet6, _classPrivateFieldGet7;
      _classPrivateFieldGet(_dragHandlers, this).push({
        key: _classPrivateFieldGet(_deviceEvent, this).START,
        handler: this.onStart
      });
      this.el.addEventListener(_classPrivateFieldGet(_deviceEvent, this).START, this.onStart, {
        passive: false
      });
      _classPrivateFieldGet(_navigation, this).addEventListener('keyup', this.onKeyboardNavigation);
      _classPrivateFieldGet(_prevButton, this).addEventListener('click', this.onPrevious);
      _classPrivateFieldGet(_nextButton, this).addEventListener('click', this.onNext);
      _classPrivateFieldGet(_indexButtons, this).forEach(btn => {
        btn.addEventListener('click', this.onIndex);
      });
      (_classPrivateFieldGet6 = _classPrivateFieldGet(_a11yPrevious, this)) === null || _classPrivateFieldGet6 === void 0 || _classPrivateFieldGet6.addEventListener('click', this.onPreviousSlide);
      (_classPrivateFieldGet7 = _classPrivateFieldGet(_a11yNext, this)) === null || _classPrivateFieldGet7 === void 0 || _classPrivateFieldGet7.addEventListener('click', this.onNextSlide);
    }
  }
  removeListeners() {
    var _classPrivateFieldGet9, _classPrivateFieldGet0;
    window.removeEventListener('resize', this.onResize);
    _classPrivateFieldGet(_container, this).removeEventListener('scroll', this.handleTransforms);
    while (_classPrivateFieldGet(_dragHandlers, this).length) {
      var _this$el;
      const _classPrivateFieldGet8 = _classPrivateFieldGet(_dragHandlers, this).pop(),
        key = _classPrivateFieldGet8.key,
        handler = _classPrivateFieldGet8.handler;
      (_this$el = this.el) === null || _this$el === void 0 || _this$el.removeEventListener(key, handler);
    }
    _classPrivateFieldGet(_navigation, this).removeEventListener('keyup', this.onKeyboardNavigation);
    _classPrivateFieldGet(_prevButton, this).removeEventListener('click', this.onPrevious);
    _classPrivateFieldGet(_nextButton, this).removeEventListener('click', this.onNext);
    _classPrivateFieldGet(_indexButtons, this).forEach(btn => btn.removeEventListener('click', this.onIndex));
    (_classPrivateFieldGet9 = _classPrivateFieldGet(_a11yPrevious, this)) === null || _classPrivateFieldGet9 === void 0 || _classPrivateFieldGet9.removeEventListener('click', this.onPreviousSlide);
    (_classPrivateFieldGet0 = _classPrivateFieldGet(_a11yNext, this)) === null || _classPrivateFieldGet0 === void 0 || _classPrivateFieldGet0.removeEventListener('click', this.onNextSlide);
  }
  destroy() {
    this.removeListeners();
    this.children.forEach(item => {
      _classPrivateFieldGet(_observer, this).unobserve(item);
    });
    _classPrivateFieldSet(_observer, this, null);
  }
}
_defineProperty(CarouselManager, "DRAG_THRESHOLD", 50);
_defineProperty(CarouselManager, "MOBILE", 'mobile');
_defineProperty(CarouselManager, "TABLET", 'tablet');
_defineProperty(CarouselManager, "DESKTOP", 'desktop');
setGlobal('svs.components.lbUi.carousel.CarouselManager', CarouselManager);

 })(window);